import Paragraph from '@/design_system/Typography/Paragraph';
import { useRequestContext } from '@/routes/Requests/contexts/RequestContext';
import useViewPort from '@/utils/useViewport';

import WorkshopPriceLabel from '../WorkshopPriceLabel/WorkshopPriceLabel';

export const PricesContainer = ({
  isDisabled = false,
  children,
  noVATAppliedOnWorkshopPrice,
}: {
  isDisabled?: boolean;
  children?: React.ReactNode;
  noVATAppliedOnWorkshopPrice?: boolean;
}) => {
  const { isMobile, isTablet } = useViewPort();
  const { view: requestView } = useRequestContext();

  const showWorkshopPrice = requestView.workshopPrice.shown;
  const showOrganizationPrice = requestView.organizationPrice.shown;
  const showHeaderLine = showWorkshopPrice && showOrganizationPrice;

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns:
          showOrganizationPrice && showWorkshopPrice
            ? isMobile || isTablet
              ? '1fr 1fr 1fr'
              : '2fr 1fr 1fr'
            : '2fr 1fr',
        padding: '12px',
        gap: '0.5rem',
        backgroundColor: 'var(--color-neutral-100)',
        alignItems: 'center',
      }}
    >
      {showHeaderLine && (
        <>
          <PricesHeaderLine
            isDisabled={isDisabled}
            noVATAppliedOnWorkshopPrice={noVATAppliedOnWorkshopPrice}
          />
          <hr style={{ gridColumn: '1 / -1' }} />
        </>
      )}

      {children}
    </div>
  );
};

const PricesHeaderLine = ({
  isDisabled = false,
  noVATAppliedOnWorkshopPrice,
}: {
  isDisabled?: boolean;
  noVATAppliedOnWorkshopPrice?: boolean;
}) => {
  const { view: requestView } = useRequestContext();

  return (
    <>
      <div />
      {requestView.workshopPrice.shown && (
        <Paragraph size="200" color={isDisabled ? 'disabled' : 'secondary'} align="right">
          <WorkshopPriceLabel
            noVATApplied={noVATAppliedOnWorkshopPrice}
            size="200"
            justifyContent="end"
          />
        </Paragraph>
      )}
      {requestView.organizationPrice.shown && (
        <Paragraph size="200" color={isDisabled ? 'disabled' : 'secondary'} align="right">
          {requestView.organizationPrice.label}
        </Paragraph>
      )}
    </>
  );
};
